import { useEffect } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { fetchTopEditors } from '../../store/slices/user.slice'
import { Loader } from '../FarmerMotion/Loader'
import { Link } from 'react-router-dom'
import { topAnimesImages } from '../../services/images.service'
import clsx from 'clsx'

export function TopEditors() {
  const dispatch = useDispatch()
  const topUsers = useSelector((state) => state.userModule.topEditors)
  const isLoading = useSelector((state) => state.userModule.isLoading)

  useEffect(() => {
    dispatch(fetchTopEditors())
      .unwrap()
      .then(() => {})
      .catch((err) => {
        console.error('❌ שגיאה ב־fetchTopEditors:', err)
      })
  }, [dispatch])

  if (isLoading || !topUsers.length) return <Loader />
  return (
    <>
      {/* כותרת */}
      <div className="flex justify-center md:justify-between items-center mb-4">
        <h2 className="text-h2 text-softText">
          עורכים / משפיענים מובילים באתר
        </h2>
        {/* <div className="hidden md:block gap-2">
          <div className="relative">
            <button title="All Animes">
              <img src={topAnimesImages.allAnimesTitle} alt="work with us" />
              <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full text-lg text-buttonSecondary1">
                הצטרפות כעורך
              </span>
            </button>
          </div>
        </div> */}
      </div>

      {/* רשימת העורכים */}
      <div className="grid grid-cols-2 sm:grid-cols-3 lg:grid-cols-4 gap-4 overflow-hidden">
        {topUsers.map((user, idx) => (
          <article
            key={user._id}
            className={clsx(
              'flex gap-3 items-center ml-4 relative',
              idx !== topUsers.length - 1 && 'border-l-2 border-borderM'
            )}
            aria-labelledby={`top-editor-${user._id}`}
          >
            {/* יהלום למעלה ולמטה על ה־border */}
            {idx !== topUsers.length - 1 && (
              <>
                <div
                  className="nav__diamond-TopEditor absolute left-[-4px] top-0"
                  aria-hidden="true"
                ></div>
                <div
                  className="nav__diamond-TopEditor absolute left-[-4px] bottom-0"
                  aria-hidden="true"
                ></div>
              </>
            )}

            <Link
              to={`/user/${user.username}`}
              className="flex items-center justify-center gap-3"
              title={`מעבר לפרופיל של ${user.nickname || 'המשתמש'}`}
              aria-label={`צפה בפרופיל של ${user.nickname || 'המשתמש'}`}
            >
              <img
                src={user.image || 'https://placehold.co/150X180'}
                alt={`תמונת פרופיל של ${user.nickname || 'משתמש אנונימי'}`}
                className="w-20 h-20 rounded-full border-2 border-primary mb-2"
                loading="lazy"
              />
              <div className="flex flex-col justify-center items-start">
                <h3
                  id={`top-editor-${user._id}`}
                  className="text-lg font-medium text-text"
                >
                  {user.nickname || 'לא ידוע'}
                </h3>
                <p className="text-sm text-muted">{user.postCount} כתבות</p>
              </div>
            </Link>
          </article>
        ))}
      </div>

      {/* כפתור הצטרפות בנייד */}
      {/* <div className="md:hidden flex justify-center mt-6">
        <div className="relative">
          <button title="Join us">
            <img src={topAnimesImages.allAnimesTitle} alt="Join us button" />
            <span className="absolute top-1/2 left-1/2 -translate-x-1/2 -translate-y-1/2 w-full text-lg text-buttonSecondary1">
              הצטרפות כעורך
            </span>
          </button>
        </div>
      </div> */}
    </>
  )
}
